import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const dealerDataRevisionsRequest = createAction(
  types.DEALER_DATA_REVISIONS_REQUEST,
);
export const dealerDataRevisionsSuccess = createAction(
  types.DEALER_DATA_REVISIONS_SUCCESS,
);
export const dealerDataRevisionsFailure = createAction(
  types.DEALER_DATA_REVISIONS_FAILURE,
);

export default {
  dealerDataRevisionsRequest,
  dealerDataRevisionsSuccess,
  dealerDataRevisionsFailure,
};
